// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Stack: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="m.715 5.303 5.78 2.351c.158.063.333.071.48.071.175 0 .348-.032.512-.098l5.775-2.35c.456-.177.738-.565.738-1.052 0-.486-.281-.875-.715-1.052L7.505.845A1.384 1.384 0 0 0 6.49.848L.715 3.198C.281 3.375 0 3.788 0 4.225c0 .438.281.875.715 1.078Zm6.301-3.24 5.37 2.162-5.402 2.188-5.37-2.163 5.402-2.187Zm6.268 8.134a.655.655 0 0 0-.774 1.001l-5.526 2.238-5.496-2.237a.656.656 0 0 0-.772-1.002C.28 10.35 0 10.787 0 11.25c0 .462.281.874.715 1.05l5.78 2.354c.158.063.333.096.48.096.175 0 .348-.033.512-.098l5.775-2.35c.456-.202.738-.59.738-1.052 0-.462-.282-.9-.716-1.053Zm0-3.5a.654.654 0 0 0-.856.36.654.654 0 0 0 .082.641L6.984 9.936 1.488 7.7a.654.654 0 0 0 .083-.642.654.654 0 0 0-.856-.36C.281 6.85 0 7.291 0 7.753c0 .462.281.872.715 1.05l5.778 2.352a1.374 1.374 0 0 0 1.017-.003l5.775-2.35c.433-.202.715-.612.715-1.05 0-.437-.282-.902-.716-1.055Z"
            />
        </svg>
    );
};

export default React.memo(Stack);
